import { PropTypes } from "prop-types"

import Input from "../Input"

const numberRegex = /\d/

export const InputText = ({ shouldPreventNumbers = false, ...rest }) => {
  const handlePreventNumbers = e => {
    if (shouldPreventNumbers) {
      return e.key.match(numberRegex) && e.preventDefault()
    }
  }
  return <Input className="oj-input-text" type="text" onKeyDown={handlePreventNumbers} {...rest} />
}

InputText.propTypes = {
  shouldPreventNumbers: PropTypes.bool,
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  placeholder: PropTypes.string
}

export default InputText
